module.exports = {
	PENDING: "pending",
	NEW_REGISTER: "newRegistered",
	ACTIVE: "active",
	UNVERIFIED: "unverified",
	SUSPENDED: "suspended",
};